import { message } from "antd";
import { serverBaseURL } from "@src/config/apollo";

// Shared by the reports, roster and invoice pages: CSV export, PDF downloads and location helpers.

const escapeCsvValue = (value) => {
    const str = value === null || value === undefined ? "" : String(value);
    return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

export const downloadCsv = (filename, headers, rows) => {
    // BOM so Excel opens £ and accented names correctly
    const csvContent = "﻿" + [headers, ...rows].map((row) => row.map(escapeCsvValue).join(",")).join("\r\n");
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
};

export const downloadBlob = (blob, filename) => {
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
};

// actualLocation is stored as untyped JSON on schedulecheckcalls/mobileservices -
// read defensively rather than assume one key shape (seen as {latitude, longitude}
// in practice, occasionally handed through as a JSON string rather than an object)
export const getLatLngPair = (location) => {
    let loc = location;
    if (typeof loc === 'string') {
        try { loc = JSON.parse(loc); } catch (e) { return null; }
    }
    if (!loc || typeof loc !== 'object') return null;

    const lat = loc.lat ?? loc.latitude ?? loc.Latitude ?? loc.coords?.lat ?? loc.coords?.latitude;
    const lng = loc.lng ?? loc.longitude ?? loc.Longitude ?? loc.long ?? loc.coords?.lng ?? loc.coords?.longitude;
    if (lat === undefined || lng === undefined || lat === null || lng === null) return null;

    const latNum = Number(lat);
    const lngNum = Number(lng);
    if (Number.isNaN(latNum) || Number.isNaN(lngNum)) return null;

    return { lat: latNum, lng: lngNum };
};

export const googleMapsUrl = (pair) => `https://www.google.com/maps?q=${pair.lat},${pair.lng}`;

// A PDF wfc-server builds (routes/customerReports.route.ts), saved straight to the
// customer's downloads - no new tab, no print dialog. path: "/reports/customer/...";
// params are added as the query string. Resolves false (after a toast) on failure.
export const downloadServerPdf = async (path, params, filename) => {
    const hide = message.loading("Preparing your PDF…", 0);
    try {
        const query = params ? `?${new URLSearchParams(Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== ""))}` : "";
        const res = await fetch(`${serverBaseURL}${path}${query}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        });
        if (!res.ok) {
            const body = await res.json().catch(() => null);
            throw new Error(body?.message || `Request failed (${res.status})`);
        }
        downloadBlob(await res.blob(), filename);
        return true;
    } catch (err) {
        message.error(err?.message || "Could not download the PDF.");
        return false;
    } finally {
        hide();
    }
};
